import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeeConfirmdicApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-confirmdic'
  }

}